import React from "react";
import './App.scss';
import Home from "./routes/home/home.component.jsx";


function App() {
  return (
    <div className="App">        
      <article>
      <Home />
      </article>
    </div>
  );
}

export default App;
